export function client(state) {
  return state.client;
}

export function user(state) {
  return state.user;
}

export function partner(state) {
  return state.partner;
}
export function isPrimaryColorDark(state) {
  return state.partner && state.partner.darkPrimary || false;
}

export function authenticated(state) {
  return state.user != null;
}

export function authorized(state) {
  return state.user && state.user.entitykey != null;
}